import React, { useEffect, useState } from 'react';
import { crmRequest } from './crmApi';
import { unitName } from './CrmCompanyFields';
export default function QuickBooksCoveragePanel({ onResolved }) {
    const [data, setData] = useState(null), [error, setError] = useState(''), [busy, setBusy] = useState(false), [selected, setSelected] = useState({});
    async function load() {
        setError('');
        try { setData(await crmRequest('/quickbooks/coverage')); } catch (e) { setError(e.message); }
    }
    useEffect(() => { load(); }, []);
    async function resolve(r) {
        setBusy(true); setError('');
        try { await crmRequest(`/quickbooks/coverage/${r.id}/resolve`, 'post', { company: selected[r.id], fingerprint: r.fingerprint }); await load(); onResolved?.(); }
        catch (e) { setError(e.message); } finally { setBusy(false); }
    }
    return <section aria-label="Vinculación de QuickBooks">
        {error && <p role="alert">{error}</p>}
        <button disabled={busy} onClick={load}>Actualizar comprobación de QuickBooks</button>
        {data ? <>
            <p>{data.enabled ? 'Vinculación automática activa.' : 'Vinculación automática pendiente de activación.'} {data.counts ? `${data.counts.linked} de ${data.counts.activeSources} registros activos vinculados. ${data.counts.conflicts} pendientes de revisión.` : 'Sin comprobación disponible.'}</p>
            {data.lastCheckedAt && <small>Última comprobación: {new Date(data.lastCheckedAt).toLocaleString('es-PA')}</small>}
            {data.counts?.unassigned > 0 && <p>{data.counts.unassigned} registros vinculados tienen una unidad sin vendedor. Revisa su asignación en la ficha de empresa.</p>}
            {(data.reviews || []).map(r => <article key={r.id} className="client-panel">
                <strong>{r.name} · {unitName(r.source.businessUnit)}</strong>
                {r.reason === 'ambiguous_match' ? <>
                    <p>Hay varias fichas posibles. Selecciona la empresa que corresponde al cliente de QuickBooks.</p>
                    <select aria-label={`Vincular ${r.name}`} disabled={busy} value={selected[r.id] || ''} onChange={e => setSelected({ ...selected, [r.id]: e.target.value })}>
                        <option value="">Seleccionar empresa</option>
                        {r.candidates.map(c => <option key={c.id} value={c.id}>{c.name} · {c.domain || c.id.slice(-6)}</option>)}
                    </select>
                    <button disabled={busy || !selected[r.id]} onClick={() => resolve(r)}>Confirmar vínculo</button>
                </> : <p>Requiere revisar los datos de origen o un vínculo duplicado antes de asignar acceso.</p>}
            </article>)}
        </> : !error && <p role="status">Comprobando vínculos…</p>}
    </section>;
}
